import React, {useState, useEffect} from 'react';

import {RECAPTCHA_ACTIONS} from '../../constants/recaptcha';
import {
  BANK_TYPES,
  CNPJ_TYPES,
  EC_REPRESENTATIVE_DATA,
  P_LIST_TYPES,
  PSR_TYPES
} from '../../constants/typesMessages';
import {useRecaptchaProtection} from '../../hooks/useRecaptchaProtection';
import {
  startChat,
  sendCNAE,
  sendAddresses,
  getAddressByCep,
  sendPartnerAnswer
} from '../../services/Api';
import {
  getAddressByCepAlternative,
  getAddressByCepAlternative2,
  getAddressByCepAlternative3
} from '../../services/Api/address/address';
import * as bankService from '../../services/bank';
import {newCheckErrors, showErrors} from '../../services/errorsMessages';
import {
  informCNAE,
  informLegalName,
  informFantasyName,
  informCNAERequest
} from '../../services/establishment';
import {
  startAddresseFromBureauFlow,
  validateAddressFromPlacesApi,
  validateAddressFromPlacesApiAlternative,
  validateAddressFromPlacesApiAlternative2,
  validateAddressFromPlacesApiAlternative3,
  validateJson,
  updateNumberOfAddress,
  updateComplementOfAddress,
  updateCityOfAddress,
  updateAddressOfAddress,
  updateStateOfAddress,
  updateNeighborhoodOfAddress,
  updateZipCodeOfAddress,
  checkPropertiesAddressFromAPI,
  userMessageAddressesHandler,
  inputAddressWithoutInfoBureau,
  addTypeToAddressFromBureau
} from '../../services/flowAddress';
import * as partnersService from '../../services/partners';
import {
  pushInteractionTagManagerChatbot,
  pushNoInteractionTagManagerChatbot
} from '../../services/tagManager';
import {useChatStore} from '../../store/slices/chatStore';
import {useEcStore} from '../../store/slices/ecStore';
import {useInteractionStore} from '../../store/slices/interactionStore';
import {
  removeMask,
  cepValidator,
  cepNotFounded,
  estadosBrasileirosValidatorBySigla,
  nameValidator,
  emailValidator,
  phoneValidator,
  cpfValidator,
  phoneMask,
  birthDateValidator,
  remSymbolAllowAccent
} from '../../utils';
import ButtonUserBar from '../ButtonUserBar';
import FlowsSelect from '../Flows/FlowsSelect';
import IconUserBar from '../IconUserBar';
import {InputUser} from '../InputUser';
import './UserBar.style.scss';
import {LOAD_BAR} from '../../constants/loadBar';
import {TYPE_CLICK} from '../../constants/tagManager';

const UserBar = () => {
  const [userMessage, setUseMessage] = useState('');
  const [representative, setRepresentative] = useState({});

  // EC Store
  const partnerSelected = useEcStore((state) => state.partnerSelected);
  const ecState = useEcStore((state) => state.ec);
  const ecStateId = useEcStore((state) => state.ec.id);
  const updateEc = useEcStore((state) => state.updateEc);
  const updatePartners = useEcStore((state) => state.updatePartners);
  const setPartnersCompleted = useEcStore(
    (state) => state.setPartnersCompleted
  );
  const selectPartner = useEcStore((state) => state.selectPartner);
  const updateAddress = useEcStore((state) => state.updateAddress);
  const setEcIdentity = useEcStore((state) => state.setEcIdentity);

  // Chat Store
  const responseType = useChatStore((state) => state.responseType);
  const blockInput = useChatStore((state) => state.blockInput);
  const chatState = useChatStore((state) => state);
  const sendMessage = useChatStore((state) => state.sendMessage);
  const setMessages = useChatStore((state) => state.setMessages);
  const responseTypeChange = useChatStore((state) => state.responseTypeChange);
  const loadMessages = useChatStore((state) => state.loadMessages);
  const setChatStageFlow = useChatStore((state) => state.setChatStageFlow);
  const responseFlowChange = useChatStore((state) => state.responseFlowChange);
  const setBankObject = useChatStore((state) => state.setBankObject);

  // Interaction Store
  const partnersTypeList = useInteractionStore(
    (state) => state.partnersTypeList
  );
  const disabledButton = useInteractionStore((state) => state.disabledButton);
  const setPartnersTypeList = useInteractionStore(
    (state) => state.setPartnersTypeList
  );
  const disabledButtonSendMessage = useInteractionStore(
    (state) => state.disabledButtonSendMessage
  );
  const setDotTyping = useInteractionStore((state) => state.setDotTyping);

  const {executeWithProtection} = useRecaptchaProtection();

  /**
   * INICIO Coleta dados básicos do EC para envio do CNPJ
   */
  const nameEcData = () => {
    const validate = nameValidator(userMessage);
    if (validate.status) {
      setRepresentative({
        ...representative,
        displayName: validate.fullname
      });
      pushInteractionTagManagerChatbot({
        ...TYPE_CLICK,
        elementContent: 'step-2:none:nome'
      });

      responseTypeChange(EC_REPRESENTATIVE_DATA.FLOW);
      responseFlowChange(EC_REPRESENTATIVE_DATA.BIRTH);

      setMessages([
        {
          text: validate.fullname,
          type: 'message-sent'
        },
        {
          text: 'Agora, sua data de nascimento?',
          type: 'message-receive'
        }
      ]);
      setUseMessage('');
      pushNoInteractionTagManagerChatbot({
        elementContent: 'step-3:none:data-nascimento'
      });
    } else {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('disabled');
    }
  };

  const birthDateEcData = () => {
    const validate = birthDateValidator(userMessage.replace(/\//g, '-'));
    if (validate.status) {
      setRepresentative({
        ...representative,
        birthDate: validate.partnerBd
      });
      pushInteractionTagManagerChatbot({
        ...TYPE_CLICK,
        elementContent: 'step-3:none:data-nascimento'
      });
      responseTypeChange(EC_REPRESENTATIVE_DATA.FLOW);
      responseFlowChange(EC_REPRESENTATIVE_DATA.PHONE);

      setMessages([
        {
          text: userMessage,
          type: 'message-sent'
        },
        {
          text: 'Qual seu telefone?',
          type: 'message-receive'
        }
      ]);
      setUseMessage('');
      pushNoInteractionTagManagerChatbot({
        elementContent: 'step-4:none:data-telefone'
      });
    } else {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('disabled');
    }
  };

  const phoneEcData = () => {
    const valueMessage = removeMask(userMessage);
    const validate = phoneValidator(valueMessage);
    if (validate.status) {
      setRepresentative({
        ...representative,
        telephoneNumber: valueMessage
      });
      pushInteractionTagManagerChatbot({
        ...TYPE_CLICK,
        elementContent: 'step-4:none:telefone'
      });
      responseTypeChange(EC_REPRESENTATIVE_DATA.FLOW);
      responseFlowChange(EC_REPRESENTATIVE_DATA.EMAIL);
      setMessages([
        {
          text: phoneMask(valueMessage),
          type: 'message-sent'
        },
        {
          text: 'Qual seu e-mail?',
          type: 'message-receive'
        }
      ]);
      setUseMessage('');
      pushNoInteractionTagManagerChatbot({
        elementContent: 'step-5:none:email'
      });
    } else {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('disabled');
    }
  };

  const emailEcData = () => {
    const validate = emailValidator(userMessage);
    if (validate.status) {
      setRepresentative({
        ...representative,
        email: userMessage
      });
      pushInteractionTagManagerChatbot({
        ...TYPE_CLICK,
        elementContent: 'step-5:none:email'
      });
      responseTypeChange(EC_REPRESENTATIVE_DATA.FLOW);
      responseFlowChange(EC_REPRESENTATIVE_DATA.CPF);

      setMessages([
        {
          text: userMessage,
          type: 'message-sent'
        },
        {
          text: 'Qual seu CPF?',
          type: 'message-receive'
        }
      ]);
      setUseMessage('');
      pushNoInteractionTagManagerChatbot({
        elementContent: 'step-6:none:cpf'
      });
    } else {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('disabled');
    }
  };

  const cpfEcData = () => {
    const valueMessage = removeMask(userMessage);
    const validate = cpfValidator(valueMessage);
    if (validate.status) {
      setEcIdentity({
        ...representative,
        cpf: validate.partnerCpf
      });
      setRepresentative({
        ...representative,
        cpf: validate.partnerCpf
      });
      pushInteractionTagManagerChatbot({
        ...TYPE_CLICK,
        elementContent: 'step-6:none:cpf'
      });
      responseTypeChange(CNPJ_TYPES.CNPJ_FLOW);
      responseFlowChange(CNPJ_TYPES.CNPJ);

      setMessages([
        {
          text: userMessage,
          type: 'message-sent'
        },
        {
          text: 'Qual o seu CNPJ?',
          type: 'message-receive'
        }
      ]);
      setUseMessage('');
      pushNoInteractionTagManagerChatbot({
        elementContent: 'step-7:none:cnpj'
      });
    } else {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('disabled');
    }
  };

  const setRepresentativeEcData = () => {
    switch (chatState.responseFlow) {
      case EC_REPRESENTATIVE_DATA.NAME:
        nameEcData();
        break;
      case EC_REPRESENTATIVE_DATA.PHONE:
        phoneEcData();
        break;
      case EC_REPRESENTATIVE_DATA.EMAIL:
        emailEcData();
        break;
      case EC_REPRESENTATIVE_DATA.BIRTH:
        birthDateEcData();
        break;
      default:
        cpfEcData();
        break;
    }
    disabledButtonSendMessage('');
  };
  /**
   * FIM Coleta dados básicos do EC para envio do CNPJ
   */

  /**
   * I start functions related to CNPJ
   * Requests confirmation of information
   * If incorrect, restart the flow, if
   * contrary goes ahead
   */
  const flowCnae = () => {
    const dataCnae = informCNAE(ecState, userMessage);
    if (!dataCnae.status) return;
    setUseMessage('');
    setDotTyping(true);
    executeWithProtection(
      (payload, token) => sendCNAE(ecStateId, payload, token),
      RECAPTCHA_ACTIONS.DATA_UPDATE,
      dataCnae.newEc
    )
      .then(function (response) {
        setDotTyping(false);
        pushInteractionTagManagerChatbot({
          ...TYPE_CLICK,
          elementContent: 'step-11:none:cnae'
        });
        const showResponse = informCNAERequest(response.data, dataCnae.value);

        // CRITICAL: Atualiza estado com primaryCnae preservado
        console.log({showResponse});
        const mergedEc = {
          ...showResponse.ec,
          ecBasicData: {
            ...showResponse.ec.ecBasicData,
            primaryCnae: dataCnae.newEc.primaryCnae
          }
        };

        updateEc(mergedEc);
        setMessages(dataCnae.messages);
        setChatStageFlow(showResponse.chatStageFlow);

        // Flow Partners questions start - usa estado atualizado
        const updatedEcState = useEcStore.getState().ec;
        let nextStep = partnersService.quizPartnersStart(
          updatedEcState,
          chatState.quizPartners
        );
        selectPartner(nextStep.selectedPartner);
        responseFlowChange(nextStep.responseFlow);
        responseTypeChange(nextStep.responseType);
        setMessages(nextStep.messages);
        disabledButtonSendMessage('');
        pushNoInteractionTagManagerChatbot({
          elementContent: 'step-12:none:proprietario-sim'
        });
      })
      .catch(function (error) {
        setDotTyping(false);
        const showResponse = newCheckErrors(
          error,
          'Por favor, informe um CNAE válido.'
        );
        setMessages(showResponse.messages);
        disabledButtonSendMessage('');
      });
  };

  const cnpjLegalName = () => {
    let dataLegalName = informLegalName(ecState, userMessage);
    setUseMessage('');
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-9:none:razao-social'
    });
    disabledButtonSendMessage('');
    setMessages(dataLegalName.messages);
    updateEc(dataLegalName.newEc);
    responseTypeChange(dataLegalName.responseType);
    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-10:none:nome-fantasia'
    });
  };

  const cnpjFantasyName = () => {
    const dataFantasyName = informFantasyName(ecState, userMessage);
    setUseMessage('');
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-10:none:nome-fantasia'
    });
    disabledButtonSendMessage('');
    updateEc(dataFantasyName.newEc);
    setMessages(dataFantasyName.messages);
    responseTypeChange(dataFantasyName.responseType);
    pushNoInteractionTagManagerChatbot({
      elementContent: 'step-11:none:cnae'
    });
  };
  /**
   * End functions related to CNPJ
   */

  /**
   * Beginning of the partners' questionnaire
   */
  const sendResponsePartners = (idQuestion, idPartner, resPartner, res) => {
    disabledButtonSendMessage('disabled');
    setDotTyping(true);
    executeWithProtection(
      (payload, token) =>
        sendPartnerAnswer(ecStateId, idQuestion, idPartner, payload, token),
      RECAPTCHA_ACTIONS.DATA_UPDATE,
      resPartner
    )
      .then(() => {
        setDotTyping(false);
        // Somente se atualizado com sucesso no patch
        updatePartners(res.partners);
        setMessages(res.messages);
        responseTypeChange(res.responseType);
        setUseMessage('');

        if (res.changePartner) {
          // Atualiza a lista com partners completado
          setPartnersCompleted(partnerSelected);
          // Seleciona o proximo partner a ser completado
          selectPartner(res.nextPartner);
          // Troca o tipo de lista de sócios para continuar
          setPartnersTypeList(res.partnersTypeList);
        }

        // If quiz from partners and partners is completed got next step
        if (res.partnersComplete) {
          selectPartner(res.partnerSelected);
          setChatStageFlow(LOAD_BAR.PARTNERS);
          flowAddress();
        }

        disabledButtonSendMessage('');
      })
      .catch((error) => {
        setDotTyping(false);
        const showResponse = newCheckErrors(error, '');
        setMessages(showResponse.messages);
        disabledButtonSendMessage('');
      });
  };

  const defineNumberPartners = () => {
    const validate = partnersService.informNumberPartners(userMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('disabled');
      return;
    }
    setUseMessage('');
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-14:none:quantos-socios'
    });
    let res = partnersService.setNumberPartners(
      validate,
      userMessage,
      partnersTypeList,
      ecState.partners
    );
    updatePartners(res.partners);

    let nextStep = partnersService.quizPartnersStart(
      {
        ...ecState,
        partners: res.partners
      },
      chatState.quizPartners,
      partnersTypeList,
      // P_LIST_TYPES.P_EMPTY,
      res.partnerSelected
    );

    // No partners in Bureau
    // setPartnersTypeList(partnersTypeList);
    setPartnersTypeList(P_LIST_TYPES.P_EMPTY);
    selectPartner(nextStep.selectedPartner);
    responseFlowChange(nextStep.responseFlow);
    responseTypeChange(nextStep.responseType);
    setMessages(res.messages.concat(nextStep.messages));
    disabledButtonSendMessage('');
  };

  const partnerUpdateName = () => {
    const validate = partnersService.informPartnerName(userMessage);
    if (!validate.status) {
      disabledButtonSendMessage('');
      setMessages(validate.error.messages);
      return;
    }

    let idQuestion = 1;

    const res = partnersService.setPartnerName(
      ecState,
      partnerSelected,
      validate,
      userMessage,
      idQuestion,
      chatState.quizPartners,
      partnersTypeList
    );

    sendResponsePartners(
      idQuestion,
      partnerSelected.id,
      {
        partnerName: validate.fullname
      },
      res
    );

    disabledButtonSendMessage('');
  };

  const partnerUpdateBirthDate = () => {
    const validate = partnersService.informPartnerBd(userMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('');
      return;
    }

    let idQuestion = 2;

    const res = partnersService.setPartnerBirthDate(
      ecState,
      partnerSelected,
      validate,
      userMessage,
      idQuestion,
      chatState.quizPartners,
      partnersTypeList
    );

    sendResponsePartners(
      idQuestion,
      partnerSelected.id,
      {
        birthDate: validate.partnerBd
      },
      res
    );

    disabledButtonSendMessage('');
  };

  const partnerUpdatePhone = () => {
    const validate = partnersService.informPartnerPh(userMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('');
      return;
    }

    let idQuestion = 3;

    const res = partnersService.setPartnerPhone(
      ecState,
      partnerSelected,
      validate,
      userMessage,
      idQuestion,
      chatState.quizPartners,
      partnersTypeList
    );

    sendResponsePartners(
      idQuestion,
      partnerSelected.id,
      {
        phone: validate.phoneNumber
      },
      res
    );

    disabledButtonSendMessage('');
  };

  const partnerUpdateEmail = () => {
    const validate = partnersService.informPartnerEmail(userMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('');
      return;
    }

    let idQuestion = 4;

    const res = partnersService.setPartnerEmail(
      ecState,
      partnerSelected,
      validate,
      userMessage,
      idQuestion,
      chatState.quizPartners,
      partnersTypeList
    );

    sendResponsePartners(
      idQuestion,
      partnerSelected.id,
      {
        email: validate.partnerEmail
      },
      res
    );

    disabledButtonSendMessage('');
  };

  const partnerUpdateCpf = () => {
    const validate = partnersService.informPartnerCpf(userMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('');
      return;
    }

    let idQuestion = 5;

    const res = partnersService.setPartnerCpf(
      ecState,
      partnerSelected,
      validate,
      userMessage,
      idQuestion,
      chatState.quizPartners,
      partnersTypeList
    );

    sendResponsePartners(
      idQuestion,
      partnerSelected.id,
      {
        cpf: validate.partnerCpf
      },
      res
    );

    disabledButtonSendMessage('');
  };
  /**
   * Fim funções relacionados aos partners
   */

  /**
   * @version 1.0.0
   * @author Tacio Camargo
   * ------- Flow Antecessor : Flow Partners----------
   * Descrição da Função:
   * Função que inicializa o fluxo de endereços:
   * --------Próximo Flow = MessageAddressFromBureau--------------
   */
  const flowAddress = () => {
    const ecStateAddresses = ecState.addresses;
    if (!ecStateAddresses || !ecStateAddresses.length) {
      let message = inputAddressWithoutInfoBureau();
      addressDispatchHandler(message);
    } else {
      let ecUpdated = validateJson(ecState.addresses);
      updateAddress(ecUpdated);
      let messages = startAddresseFromBureauFlow();
      setMessages(messages);
    }
  };

  /**
   * Fim do Flow Addresses
   */

  /**
   * Inicio das funções relacionadas ao
   * fluxo de Endereços
   */
  const addressDispatchHandler = (message) => {
    if (message.type === 'message-receive-address-type') {
      let showAddressBeforeType = {
        type: 'start-addresses-flow',
        index: message.index,
        step: 'address'
      };
      sendMessage(showAddressBeforeType);
    } else if (message.send) {
      setDotTyping(true);
      executeWithProtection(
        (payload, token) => sendAddresses(ecStateId, payload, token),
        RECAPTCHA_ACTIONS.DATA_UPDATE,
        ecState.addresses
      )
        .then(function () {
          setDotTyping(false);
          message = {
            text: '',
            type: PSR_TYPES.PSR_PAYMENT
          };
          sendMessage(message);
          setChatStageFlow(LOAD_BAR.ADDRESS);
        })
        .catch(function (error) {
          setDotTyping(false);
          const showResponse = showErrors(error, 'Endereços');
          setMessages(showResponse.messages);
        });
    } else {
      sendMessage(message);
      if (message.responseType) {
        responseTypeChange(message.responseType);
      }
    }
  };

  /**Inicio das funções que adicionam os itens do endereço do EC no endereço  que retornou da API Places*/
  const addressGetByZipcodeLoja = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    const valueMessage = removeMask(userMessage);
    const validate = cepValidator(valueMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('');
      return;
    }
    const type = 'LOJA';
    let message = userMessageAddressesHandler(userMessage, index);
    sendMessage(message);
    setUseMessage('');
    disabledButtonSendMessage('');
    getAddress(valueMessage, type);
  };

  const addressGetByZipcodeCorrespondencia = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    const valueMessage = removeMask(userMessage);
    const validate = cepValidator(valueMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('');
      return;
    }
    const type = 'CORRESPONDENCIA';
    let message = userMessageAddressesHandler(userMessage, index);
    sendMessage(message);
    setUseMessage('');
    disabledButtonSendMessage('');
    getAddress(valueMessage, type);
  };

  const addressGetByZipcodeWhenWithoutInfoBureau = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    const type = 'PADRAO';
    const valueMessage = removeMask(userMessage);
    const validate = cepValidator(valueMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      disabledButtonSendMessage('');
      return;
    }
    let message = userMessageAddressesHandler(userMessage, index);
    sendMessage(message);
    setUseMessage('');
    disabledButtonSendMessage('');
    getAddress(valueMessage, type);
  };

  /**
   * FlowAddresses
   * Componente - MessageAddressFromAPI
   * Função Antecessora - addressesQuestions
   * Coleta informações adicionadas pelo Ec para os
   * campos faltantes dos endereços que retornam da API Places
   */

  const addressFromAPIUpdateNumber = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    let textMessage = remSymbolAllowAccent(userMessage);
    let message = userMessageAddressesHandler(textMessage);
    sendMessage(message);
    let addresses = updateNumberOfAddress(
      index,
      textMessage,
      ecState.addresses
    );
    updateAddress(addresses);
    setUseMessage('');
    disabledButtonSendMessage('');
    const updatedEcState = {...ecState, addresses};
    message = checkPropertiesAddressFromAPI(updatedEcState, index);
    disabledButtonSendMessage('');
    addressDispatchHandler(message);
  };

  const addressFromAPIUpdateComplement = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    let textMessage = remSymbolAllowAccent(userMessage);
    let message = userMessageAddressesHandler(textMessage);
    sendMessage(message);
    let addresses = updateComplementOfAddress(
      index,
      textMessage,
      ecState.addresses
    );
    updateAddress(addresses);
    setUseMessage('');
    disabledButtonSendMessage('');
    const updatedEcState = {...ecState, addresses};
    message = checkPropertiesAddressFromAPI(updatedEcState, index);
    disabledButtonSendMessage('');
    addressDispatchHandler(message);
  };

  const addressFromAPIUpdateCity = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    let textMessage = remSymbolAllowAccent(userMessage);
    let message = userMessageAddressesHandler(textMessage);
    sendMessage(message);
    let addresses = updateCityOfAddress(index, textMessage, ecState.addresses);
    updateAddress(addresses);
    setUseMessage('');
    disabledButtonSendMessage('');
    const updatedEcState = {...ecState, addresses};
    message = checkPropertiesAddressFromAPI(updatedEcState, index);
    disabledButtonSendMessage('');
    addressDispatchHandler(message);
  };

  const addressFromAPIUpdateAddress = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    let textMessage = remSymbolAllowAccent(userMessage);
    let message = userMessageAddressesHandler(textMessage);
    sendMessage(message);
    let addresses = updateAddressOfAddress(
      index,
      textMessage,
      ecState.addresses
    );
    updateAddress(addresses);
    setUseMessage('');
    disabledButtonSendMessage('');
    const updatedEcState = {...ecState, addresses};
    message = checkPropertiesAddressFromAPI(updatedEcState, index);
    disabledButtonSendMessage('');
    addressDispatchHandler(message);
  };

  const addressFromAPIUpdateState = () => {
    let index = chatState.messages[chatState.messages.length - 1].index;
    let textMessage = remSymbolAllowAccent(userMessage);
    const validate = estadosBrasileirosValidatorBySigla(textMessage);
    if (!validate.status) {
      setMessages(validate.errorMessages.messages);
      return;
    } else {
      sendMessage(validate.successMessage);
    }
    let addresses = updateStateOfAddress(index, textMessage, ecState.addresses);
    updateAddress(addresses);
    setUseMessage('');
    disabledButtonSendMessage('');
    const updatedEcState = {...ecState, addresses};
    let message = checkPropertiesAddressFromAPI(updatedEcState, index);
    disabledButtonSendMessage('');
    addressDispatchHandler(message);
  };

  const addressFromAPIUpdateNeighborhood = () => {
    let textMessage = remSymbolAllowAccent(userMessage);
    let message = userMessageAddressesHandler(textMessage);
    sendMessage(message);
    let index = chatState.messages[chatState.messages.length - 1].index;
    let addresses = updateNeighborhoodOfAddress(
      index,
      textMessage,
      ecState.addresses
    );
    updateAddress(addresses);
    setUseMessage('');
    disabledButtonSendMessage('');
    const updatedEcState = {...ecState, addresses};
    message = checkPropertiesAddressFromAPI(updatedEcState, index);
    disabledButtonSendMessage('');
    addressDispatchHandler(message);
  };

  const addressFromAPIUpdateZipcode = () => {
    const valueMessage = removeMask(userMessage);
    const validate = cepValidator(valueMessage);
    if (!validate.status) {
      setMessages(validate.error.messages);
      return;
    }
    let message = userMessageAddressesHandler(userMessage);
    sendMessage(message);
    let index = chatState.messages[chatState.messages.length - 1].index;
    let addresses = updateZipCodeOfAddress(
      index,
      valueMessage,
      ecState.addresses
    );
    updateAddress(addresses);
    setUseMessage('');
    disabledButtonSendMessage('');
    const updatedEcState = {...ecState, addresses};
    message = checkPropertiesAddressFromAPI(updatedEcState, index);
    addressDispatchHandler(message);
  };
  /**Fim das funções que adicionam os itens do endereço do EC */

  /**Inicio das funções referente a requisição da API de CEP */
  const showAddressFromAPI = (type, index) => {
    let message = {
      text: `Encontrei esse endereço vinculado ao seu CNPJ:`,
      type: 'message-receive',
      index: index,
      step: 'address'
    };
    sendMessage(message);
    responseTypeChange('disabled');
    message = {
      type: 'start-addresses-flow',
      message: {
        type
      },
      index: index,
      step: 'address'
    };

    sendMessage(message);
  };

  const requestAddressSuccess = (addressToUpdateReducer, type) => {
    let index = addressToUpdateReducer.length - 1;
    updateAddress(addressToUpdateReducer);
    showAddressFromAPI(type, index);
    responseTypeChange('disabled');
  };

  const requestAddressError = () => {
    const showError = cepNotFounded();
    setMessages(showError.messages);
    const types = [];
    for (const address of ecState.addresses) {
      types.push(...address.types);
    }
    let index = ecState.addresses.length - 1;
    let message = addTypeToAddressFromBureau(types, index);
    addressDispatchHandler(message);
  };

  const getAddressByCepAlternativeThree = (cep, type) => {
    setDotTyping(true);
    getAddressByCepAlternative3(cep)
      .then(function (response) {
        setDotTyping(false);
        let addressToUpdateReducer = validateAddressFromPlacesApiAlternative3(
          ecState.addresses,
          response.data,
          type
        );
        requestAddressSuccess(addressToUpdateReducer, type);
      })
      .catch(() => {
        setDotTyping(false);
        if (type === 'PADRAO') {
          const showError = cepNotFounded();
          setMessages(showError.messages);
          let message = inputAddressWithoutInfoBureau();
          addressDispatchHandler(message);
        } else {
          requestAddressError();
        }
      });
  };

  const getAddressByCepAlternativeTwo = (cep, type) => {
    setDotTyping(true);
    getAddressByCepAlternative2(cep)
      .then(function (response) {
        setDotTyping(false);
        let addressToUpdateReducer = validateAddressFromPlacesApiAlternative2(
          ecState.addresses,
          response.data,
          type
        );
        requestAddressSuccess(addressToUpdateReducer, type);
      })
      .catch(() => {
        setDotTyping(false);
        getAddressByCepAlternativeThree(cep, type);
      });
  };

  const getAddressByCepAlternativeOne = (cep, type) => {
    setDotTyping(true);
    getAddressByCepAlternative(cep)
      .then(function (response) {
        setDotTyping(false);
        let addressToUpdateReducer = validateAddressFromPlacesApiAlternative(
          ecState.addresses,
          response.data,
          type
        );
        requestAddressSuccess(addressToUpdateReducer, type);
      })
      .catch(() => {
        setDotTyping(false);
        getAddressByCepAlternativeTwo(cep, type);
      });
  };

  function getAddress(cep, type) {
    pushInteractionTagManagerChatbot({
      ...TYPE_CLICK,
      elementContent: 'step-15:none:cep'
    });
    setDotTyping(true);
    getAddressByCep(cep)
      .then(function (response) {
        setDotTyping(false);
        let addressToUpdateReducer = validateAddressFromPlacesApi(
          ecState.addresses,
          response.data,
          type
        );
        requestAddressSuccess(addressToUpdateReducer, type);
      })
      .catch(() => {
        setDotTyping(false);
        getAddressByCepAlternativeOne(cep, type);
      });
  }

  /**Fim das funções referente a requisição da API de CEP */

  /**
   * Fim das funções relacionadas ao fluxo
   * de endereços
   */

  /** Inicio etapa dos dados bancários */
  // Flow Banks
  const setDataOfBank = () => {
    const bankObject = bankService.typeDataUpdate(
      chatState.responseFlow,
      userMessage,
      chatState.bankObject,
      chatState.banksList
    );

    setUseMessage('');
    setBankObject(bankObject.bank);
    setMessages(bankObject.messages);
    responseFlowChange(bankObject.responseFlowChange);
    responseTypeChange(bankObject.responseTypeChange);
    disabledButtonSendMessage('');
  };

  /** Fim etapa dos
   *  dados bancários
   */

  /**
   * Home Main functions of the component
   */
  const defaultMessage = () => {
    let message = {
      text: userMessage,
      target: 'cnpj',
      type: 'response-sent'
    };
    sendMessage(message);
    setUseMessage('');
    disabledButtonSendMessage('');
  };

  /**
   * All messages that are not defined in components
   * in the MainContent component are imputed in the default
   * used for message.type: 'response-sent'; (Green balloon - editable)
   */
  const submitMessage = (e) => {
    e.preventDefault();

    if (userMessage === '') return;

    if (userMessage === '0000') return;

    if (userMessage === '00000-000') return;

    if (disabledButton === 'disabled') return;

    disabledButtonSendMessage('disabled');

    switch (responseType) {
      case EC_REPRESENTATIVE_DATA.FLOW:
        setRepresentativeEcData();
        break;
      case 'informations-cnpj-legal-name':
        cnpjLegalName();
        break;
      case 'informations-cnpj-fantasy-name':
        cnpjFantasyName();
        break;
      case 'informations-cnpj-cnae':
        flowCnae();
        break;

      case 'define-number-partners':
        defineNumberPartners();
        break;
      case 'partner-name':
        partnerUpdateName();
        break;
      case 'partner-birth-date-input':
        partnerUpdateBirthDate();
        break;
      case 'partner-phone-input':
        partnerUpdatePhone();
        break;
      case 'partner-email-input':
        partnerUpdateEmail();
        break;
      case 'partner-cpf-input':
        partnerUpdateCpf();
        break;

      case 'address-zipcode-from-api-input':
        addressFromAPIUpdateZipcode();
        break;
      case 'address-zipcode-loja-from-api-input':
        addressGetByZipcodeLoja();
        break;
      case 'address-zipcode-correspondencia-from-api-input':
        addressGetByZipcodeCorrespondencia();
        break;
      case 'address-zipcode-without-info-bureau-input':
        addressGetByZipcodeWhenWithoutInfoBureau();
        break;
      case 'address-number-from-api-input':
        addressFromAPIUpdateNumber();
        break;
      case 'address-complement-from-api-input':
        addressFromAPIUpdateComplement();
        break;
      case 'address-city-from-api-input':
        addressFromAPIUpdateCity();
        break;
      case 'address-address-from-api-input':
        addressFromAPIUpdateAddress();
        break;
      case 'address-state-from-api-input':
        addressFromAPIUpdateState();
        break;
      case 'address-neighborhood-from-api-input':
        addressFromAPIUpdateNeighborhood();
        break;

      case BANK_TYPES.BANK_FLOW:
        setDataOfBank();
        break;

      default:
        defaultMessage();
        break;
    }
  };

  useEffect(() => {
    const chatStart = startChat();
    loadMessages(chatStart);
    responseFlowChange('');
    responseTypeChange('disabled');
  }, [loadMessages, responseFlowChange, responseTypeChange]);

  return (
    <>
      {chatState.responseFlow !== 'hidden' && (
        <div className="user-bar">
          {responseType === CNPJ_TYPES.CNPJ_FLOW && (
            <FlowsSelect
              onSubmit={submitMessage}
              valueType={responseType}
              valueFlow={chatState.responseFlow}
              disabled={blockInput}
              value={userMessage}
              onChange={(e) => setUseMessage(e.target.value)}
            />
          )}{' '}
          {responseType !== CNPJ_TYPES.CNPJ_FLOW && (
            <form onSubmit={submitMessage}>
              <div className="user-bar-group-2">
                <IconUserBar />
                <InputUser
                  valueType={responseType}
                  value={userMessage}
                  onChange={(e) => setUseMessage(e.target.value)}
                  disabled={blockInput}
                />{' '}
                <ButtonUserBar />
              </div>{' '}
            </form>
          )}{' '}
        </div>
      )}
    </>
  );
};

export default UserBar;
